const getters = {
  validItems: state => {
    return state.items.filter(item => item.valid);
  }
};

export default getters;



// WEBPACK FOOTER //
// ./client/store/modules/area/areaGetters.js